import { environment } from './../../environments/environment';
import { ImageModel } from '../models/image.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../app.service';
import { Injectable } from '@angular/core';
import Auth from '../helpers/auth';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ImageService extends AppService<ImageModel> {

  private subject = new Subject<any>();
  getSubject(): Observable<any> {
    return this.subject.asObservable();
  }
  constructor(http: HttpClient) {
    super(http);
  }

  private setImageInUser() {
    const image = new ImageModel();
    const user = Auth.getUser();
    image.url = `${environment.blobUrl}/${user.id}.png?v=${new Date().getTime()}`;
    user.foto = image;
    localStorage.setItem('user', btoa(JSON.stringify(user)));
  }

  async updateUser(id: string, photo: ImageModel) {
    const result = await this.postAsync(`Account/AtualizarFotoPerfil`, {FotoPerfil: photo.imageData})
      .then(() => {
          this.setImageInUser();
          this.subject.next();
      })
      .catch();
    return result;
  }

  async getDependent(id: string) {
    const result = await this.getAsync(`Responsible/${Auth.getUser().id}/Dependent/${id}/Photo`);
    return result;
  }

  async updateDependent(id: string, photo: ImageModel) {
    const result = await this.postAsync(`Responsible/${Auth.getUser().id}/Dependent/${id}/Photo`, photo);
    return result;
  }

  async findImage(url) {
    const result = await this.findImageInBlob(url);
    return result;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/image.service.ts